export default "__VITE_ASSET__BKe0r$ux__"